export default __webpack_public_path__ + "images/P8.07f2e83.png";